import React from 'react';

/** Inline status for settings card headers — does not add a block above the card. */
export function SettingsCardSavedStatus({
  saved,
  className = 'text-sm',
  children = 'Gespeichert.',
}: {
  saved: boolean;
  /** Override the type scale when the status sits next to smaller helper text. */
  className?: string;
  children?: React.ReactNode;
}) {
  if (!saved) return null;
  return (
    <span className={`shrink-0 font-medium text-emerald-600 ${className}`} role="status">
      {children}
    </span>
  );
}
